import React, { useEffect } from "react";
import "../css/page.css";

const SubPage = ({ page }) => {
  var desc = document.getElementsByClassName("description");

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    let langCode = urlParams.get("langcode")?.toLowerCase() || "tr";
    const theme = urlParams.get("theme")?.toLowerCase() || "dark";

    // Body'e tema class'ı ekle
    document.body.classList.add(theme);

    // Hem langCode hem theme içeren istek URL'si
    const requestUrl = `${process.env.REACT_APP_CONTENTLIST_API_URL}/${page}?langCode=${langCode}&theme=${theme}`;
    console.log("Fetch URL:", requestUrl);

    fetch(requestUrl)
      .then((r) => r.json())
      .then((data) => {
        if (desc[0]) {
          desc[0].innerHTML = data.description;
        }
      })
      .catch((error) => {
        console.error("İçerik alınırken hata:", error);
      });
  }, [page]);

  return (
    <>
      <div className="description"></div>
    </>
  );
};

export default SubPage;
